import { Image } from '../domain/models/commons/Image'

export interface Association {
  id: string
  type: string
  value: {
    title: string
    text: string
    imageStyle?: {
      height?: string
      maxWidth?: string
      marginLeft?: string
      transform?: string
    }
    image?: {
      url: string
      description: string
    }
    link: {
      id: string
      type: string
      value: {
        name: string
        url: string
        external: boolean
      }
    }
  }
}

export const associations: Association[] = [
  {
    id: 'assoc-1',
    type: 'textsection-hyperlinked-image',
    value: {
      title: 'DIAS',
      text: 'Billing guide for DIAS',
      imageStyle: {
        height: '150px',
        maxWidth: '180px',
        marginLeft: '-20px',
      },
      image: {
        url: '/DIAS.jpg',
        description: 'DIAS Logo',
      } as Image,
      link: {
        id: 'link-1',
        type: 'external_link',
        value: {
          name: 'Visit',
          url: 'https://www.safetyandquality.gov.au/standards/diagnostic-imaging/diagnostic-imaging-accreditation-scheme',
          external: true,
        },
      },
    },
  },
  {
    id: 'assoc-2',
    type: 'textsection-hyperlinked-image',
    value: {
      title: 'ADIA',
      text: 'Billing guide for ADIA',
      imageStyle: {
        height: '200px',
        maxWidth: '240px',
      },
      image: {
        url: '/ADIA.jpg',
        description: 'ADIA Logo',
      } as Image,
      link: {
        id: 'link-2',
        type: 'external_link',
        value: { name: 'Visit', url: 'https://www.adia.asn.au/', external: true },
      },
    },
  },
  {
    id: 'assoc-3',
    type: 'textsection-hyperlinked-image',
    value: {
      title: 'AHPRA',
      text: 'Billing guide for AHPRA',
      imageStyle: {
        height: '150px',
        maxWidth: '180px',
      },
      image: {
        url: '/AHPRA.png',
        description: 'AHPRA Logo',
      } as Image,
      link: {
        id: 'link-3',
        type: 'external_link',
        value: { name: 'Visit', url: 'https://www.ahpra.gov.au/', external: true },
      },
    },
  },
  {
    id: 'assoc-4',
    type: 'textsection-hyperlinked-image',
    value: {
      title: 'ASA',
      text: 'Billing guide for ASA',
      imageStyle: {
        height: '150px',
        maxWidth: '180px',
        marginLeft: '-30px',
      },
      image: {
        url: '/ASA.jpg',
        description: 'ASA Logo',
      } as Image,
      link: {
        id: 'link-4',
        type: 'external_link',
        value: { name: 'Visit', url: 'https://www.sonographers.org/', external: true },
      },
    },
  },
  {
    id: 'assoc-5',
    type: 'textsection-hyperlinked-image',
    value: {
      title: 'AMSIG',
      text: 'Billing guide for AMSIG',
      imageStyle: {
        height: '150px',
        maxWidth: '180px',
        marginLeft: '-36px',
      },
      image: {
        url: '/AMSIG.jpg',
        description: 'AMSIG Logo',
      } as Image,
      link: {
        id: 'link-5',
        type: 'external_link',
        value: { name: 'Visit', url: 'https://www.amsig.org/', external: true },
      },
    },
  },
  {
    id: 'assoc-6',
    type: 'textsection-hyperlinked-image',
    value: {
      title: 'ASMIRT',
      text: 'Billing guide for ASMIRT',
      imageStyle: {
        height: '150px',
        maxWidth: '180px',
        marginLeft: '-56px',
      },
      image: {
        url: '/ASMIRT.png',
        description: 'ASMIRT Logo',
      } as Image,
      link: {
        id: 'link-6',
        type: 'external_link',
        value: { name: 'Visit', url: 'https://asmirt.org/', external: true },
      },
    },
  },
  {
    id: 'assoc-7',
    type: 'textsection-hyperlinked-image',
    value: {
      title: 'RANZCR',
      text: 'Billing guide for RANZCR',
      imageStyle: {
        height: '280px',
        maxWidth: '350px',
        marginLeft: '180px',
      },
      image: {
        url: '/RANZCR.png',
        description: 'RANZCR Logo',
      } as Image,
      link: {
        id: 'link-7',
        type: 'external_link',
        value: { name: 'Visit', url: 'https://www.ranzcr.com/', external: true },
      },
    },
  },
  {
    id: 'assoc-spacer',
    type: 'textsection-hyperlinked-image',
    value: {
      title: 'SPACER',
      text: '',
      image: {
        url: '',
        description: '',
      } as Image,
      link: {
        id: 'link-spacer',
        type: 'external_link',
        value: { name: '', url: '', external: false },
      },
    },
  },
  {
    id: 'assoc-8',
    type: 'textsection-hyperlinked-image',
    value: {
      title: 'ANZ',
      text: 'Billing guide for ANZ',
      imageStyle: {
        height: '280px',
        maxWidth: '350px',
        marginLeft: '-400px',
        transform: 'translateX(-100px)',
      },
      image: {
        url: '/ANZ.png',
        description: 'ANZ Logo',
      } as Image,
      link: {
        id: 'link-8',
        type: 'external_link',
        value: { name: 'Visit', url: 'https://www.anzsnm.org.au/', external: true },
      },
    },
  },
]
